// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDRI_LA5j5FXxJRx1SSxBC3DjAEIdw4klg",
  authDomain: "sec-data-app.firebaseapp.com",
  projectId: "sec-data-app",
  storageBucket: "sec-data-app.firebasestorage.app",
  messagingSenderId: "284152096087",
  appId: "1:284152096087:web:435cf1a6ffd3c2c3334a12"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
